import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { IconName } from 'src/app/components/icon/icons/icon-map';

@Component({
  selector: 'app-input-wrapper',
  templateUrl: './input-wrapper.component.html',
  styleUrls: ['./input-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
})
export class InputWrapperComponent {
  readonly id = input<string | undefined>(undefined);
  readonly titleIconId = input<string | undefined>(undefined);
  readonly titleLabel = input('');
  readonly titleIcon = input<IconName | undefined>(undefined);
  readonly infoLabel = input('');
  readonly invalid = input(false);
  readonly titleIconClick = output<void>();
}
